export const getDashboardGradient = (
	gradientFrom: string,
	gradientTo: string,
) =>
	`radial-gradient(81.07% 100% at 50.13% 100%, ${gradientTo} 49.62%, ${gradientFrom} 100%)`;
